'use client';

import { useState } from 'react';
import Image from 'next/image';
import ThrowbackModal, { type ThrowbackGalleryData, type ThrowbackPhotoData } from '@/components/common/ThrowbackModal';
import type { ArchivedGalleryPreview } from '@/components/common/ThrowbackStrip';

interface Props {
  gallery: ThrowbackGalleryData;
  photos: ThrowbackPhotoData[];
  archivedGalleries?: ArchivedGalleryPreview[];
}

export default function ThrowbackTeaserClient({ gallery, photos, archivedGalleries = [] }: Props) {
  const [open, setOpen] = useState(false);
  const preview = photos.slice(0, 3);

  return (
    <>
      <div className="throwback-teaser">
        <div className="throwback-teaser-top">
          <span className="throwback-teaser-label">CELEB THROWBACK</span>
          <button className="throwback-teaser-link" onClick={() => setOpen(true)} type="button">
            See all →
          </button>
        </div>
        <button className="throwback-teaser-row" onClick={() => setOpen(true)} type="button">
          {preview.map((photo) => (
            <div key={photo.id} className="throwback-teaser-card">
              <Image
                src={photo.image_url}
                alt={photo.celebrity_name}
                width={160}
                height={120}
                className="throwback-teaser-img"
                style={{ objectFit: 'cover' }}
              />
              <div className="throwback-teaser-name">{photo.celebrity_name}</div>
            </div>
          ))}
        </button>
      </div>

      {open && (
        <ThrowbackModal
          gallery={gallery}
          photos={photos}
          archivedGalleries={archivedGalleries}
          onClose={() => setOpen(false)}
        />
      )}
    </>
  );
}
